import React from 'react';
import { ElementConfigType } from '../store/type';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

export const TextContentComponent: MyComponentType<Props> = (props: Props) => {
  const { id, privateSchema, config, parentNodeIsBody } = props;

  return (
    <p
      style={Object.assign(
        parentNodeIsBody
          ? {
              fontSize: privateSchema?.fontSize,
              fontWeight: privateSchema?.fontWeight,
              opacity: privateSchema?.opacity,
              textAlign: privateSchema?.textAlign,
              color: privateSchema?.color,
              lineHeight: `${privateSchema?.lineHeight}px`,
              whiteSpace: 'pre-line',
              // paddingBottom: 16, // 在主页面下 直接加paddingBottom
            }
          : {
              fontSize: privateSchema?.fontSize,
              fontWeight: privateSchema?.fontWeight,
              opacity: privateSchema?.opacity,
              textAlign: privateSchema?.textAlign,
              color: privateSchema?.color,
              lineHeight: `${privateSchema?.lineHeight}px`,
              whiteSpace: 'pre-line',
            },
      )}
      id={id}
    >
      {privateSchema?.text || config?.text}
    </p>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/TextContentComponentDefinition'));

TextContentComponent.definition = {
  // id: 'text-content-component',
  id: ComponentIdEnum.TEXT_CONTENT_COMPONENT,
  name: '内容文本组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app-dev/dIVTg-dEwgXAOViujW2tP.png?image_process=resize,w_200',
  position: 7, // 显示顺序
  config: {
    text: 'FEZiBO strives',
  },
  privateSchema: {
    text: 'FEZiBO strives to provide ergonomic solutions to our customers for home furnishings and work-life integration problems.',
    fontSize: 16, // 16
    fontWeight: 500,
    // eslint-disable-next-line @iceworks/best-practices/recommend-add-line-height-unit
    lineHeight: 24, // 24
    opacity: 0.6,
  },
  category: 'text',
  configForm: ConfigHOC(ConfigForm),
};
